<template>
  <section class="view templates-view">
    <section class="surface">
      <div class="surface-head">
        <div>
          <h2>被分享的 Job</h2>
          <span>{{ jobTemplates.length }} 个被分享 Job</span>
        </div>
        <div class="surface-actions">
          <el-button :icon="icons.Refresh" @click="loadJobTemplates">
            刷新
          </el-button>
        </div>
      </div>

      <el-table
        :data="jobTemplates"
        row-key="id"
        class="template-table"
        height="620"
        empty-text="暂无被分享的 Job"
      >
        <el-table-column label="分享 Job" min-width="240">
          <template #default="{ row }">
            <div class="job-name">
              <strong>{{ row.step || '-' }}</strong>
              <span>{{ row.step_desc || '未填写描述' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="方式" width="92">
          <template #default="{ row }">
            <el-tag :type="methodTagType(row.http_type)" effect="light">
              {{ row.http_type || 'GET' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="分享人" width="150">
          <template #default="{ row }">
            <div class="template-owner">
              <span>{{ row.owner_username || '-' }}</span>
              <el-tag v-if="row.shared_by_me" size="small" effect="plain">我</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="规则" width="82" align="center">
          <template #default="{ row }">{{ row.rule_count || 0 }}</template>
        </el-table-column>
        <el-table-column label="URL" min-width="320" show-overflow-tooltip>
          <template #default="{ row }">{{ row.url || '-' }}</template>
        </el-table-column>
        <el-table-column label="更新时间" width="168">
          <template #default="{ row }">{{ formatDateTime(row.updated_at) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="148" fixed="right">
          <template #default="{ row }">
            <el-button
              type="primary"
              size="small"
              :icon="icons.Download"
              :loading="copyingJobTemplateId === Number(row.id)"
              @click="copyJobTemplate(row.id)"
            >
              导入
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>
  </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { Download, Refresh } from "@element-plus/icons-vue";
import { formatDateTime, methodTagType } from "../utils/job-display";

export default {
  name: "TemplatesPage",

  data() {
    return {
      icons: {
        Download,
        Refresh,
      },
    };
  },

  computed: {
    ...mapState(["jobTemplates", "copyingJobTemplateId"]),
  },

  mounted() {
    this.loadJobTemplates();
  },

  methods: {
    ...mapActions(["loadJobTemplates", "copyJobTemplate"]),
    formatDateTime,
    methodTagType,
  },
};
</script>
